import React, { FC } from "react";
import { Link, LinkProps } from "react-router-dom";
import { mergePersistedQueryArgs, useKeeperParams } from "./NavLink";
import { KeepProps, Nesting, WithParams, Toggleable } from "./types";
import { useRouteMatch } from "react-router";

/**
 * A nest that will always put your path at the end of any location you are on.
 * Differs from nest on a link in that nest will put your `to` at the end of the current path in route structure,
 * infiniteNest will put at an the end of any the current page path.
 * Useful for routed modals that may appear over any content.
 * @param to
 */
export const infiniteNestLink = (to: string): LinkProps["to"] => {
  return ({ pathname, ...rest }) => ({
    pathname: pathname + to,
    ...rest
  });
};

const PLink: FC<LinkProps & KeepProps & Nesting & WithParams & Toggleable> = ({
  nest,
  persist,
  to,
  params,
  ...props
}) => {
  const { path, params: rootParams } = useRouteMatch();
  const keepers = useKeeperParams(persist);
  const root = nest ? path : undefined;
  const newTo = !props.disabled
    ? mergePersistedQueryArgs(to, {
        keepers,
        root,
        params: {
          ...rootParams,
          ...params
        }
      })
    : "";

  if (props.disabled) {
    props.className = props.className
      ? props.className + " disabled"
      : "disabled";
  }

  return <Link {...props} to={newTo} />;
};
export default PLink;
